// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IButtonStyles } from "@fluentui/react";
import type { ITheme } from "@fluentui/react/lib/Styling";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { getStandardControlSemanticColorsWithTheme } from "@1js/acui-common";
import { isThemingEnabled } from "@1js/acui-theme";

import { fastDisabled } from "../../../Ribbon/ribbonStylingConstants";

export interface RibbonControlGroupClassNames {
  root: string;
  rootFastDisabled: string;
}

export const getRibbonControlGroupClassNames = memoizeFunction(
  (): RibbonControlGroupClassNames => {
    return mergeStyleSets({
      root: {
        display: "inline-block",
        verticalAlign: "top",
      },
      rootFastDisabled: fastDisabled,
    });
  }
);

export const getOverflowLauncherStyles = memoizeFunction(
  (theme: ITheme): IButtonStyles => {
    const semanticColors = getStandardControlSemanticColorsWithTheme(theme);
    return {
      icon: {
        fill: isThemingEnabled() ? semanticColors.textColor : "#444444",
      },
    };
  }
);
